import React from "react";
import SEO from "./SEO";

const SERVICES = [
	{
		icon: 'fa-building-o',
		title: 'Genel Bina Yönetimi',
		text: 'Tecrübeli kadromuzla tüm gelir-gider hesaplarınızı ve defterlerinizi tutar; personel bordro ve SGK işlemlerinizi yapar; genel kurul hazırlıklarınızı titizlikle organize eder. Teknik arıza/bakım, temizlik, güvenlik, bahçe bakımı ve haşere ilaçlama hizmetlerini bütünsel bir disiplin içinde yönetiriz.',
	},
	{
		icon: 'fa-line-chart',
		title: 'Bütçe Yönetimi',
		text: 'Aidat bütçeniz Proteam Yönetim hesap uzmanlarınca yapılarak giderlerin bütçeye uygun gerçekleşip gerçekleşmediği daimî kontrol altında tutulur. Cari ödemeleriniz dengeli yönetilir; gerekli durumlarda yatırım bütçeleri hazırlanarak onaya sunulur.',
	},
	{
		icon: 'fa-users',
		title: 'Taşeron Hizmet Yönetimi',
		text: 'Site veya apartmanınızdaki yaşamın konforunu üst seviyede tutmak için kritik birimleri (muhasebe, teknik, güvenlik, temizlik, peyzaj ve ilaçlama) görev tanımlarına uygun yönetir; tesisinizin varlık değerinin yükselmesini sağlarız.',
	},
	{
		icon: 'fa-balance-scale',
		title: 'Hukuk Hizmetleri',
		text: 'Geçmiş deneyimlerimizle çıkabilecek hukuki problemlere proaktif müdahale ederek hem danışmanlık hem de gerekli yöntem ve çözümleri sunuyoruz. 634 sayılı Kat Mülkiyeti Kanunu ve ilgili tüm mevzuata uygun çalışırız.',
	},
	{
		icon: 'fa-cogs',
		title: 'Teknik Hizmetler',
		text: 'Asansör, mekanik, elektrik ve havuz sistemleri başta olmak üzere tüm teknik ekipmanların periyodik bakım anlaşmalarını yapar; oluşan arızalara hızlı müdahale ile çözüm üretiriz.',
	},
	{
		icon: 'fa-magic',
		title: 'Temizlik Hizmetleri',
		text: 'Tüm ortak alanların temizlik işlerinin profesyonelce yürütülmesi için personelin eğitimini ve idamesini sağlarız. Taşeron firma seçim ve denetim süreçlerini uçtan uca yönetiriz.',
	},
	{
		icon: 'fa-shield',
		title: 'Güvenlik Hizmetleri',
		text: 'Resmi lisanslı güvenlik firmalarıyla çalışarak sakinlerin huzurlu ve güvenli bir ortamda yaşamlarını sürdürmesini sağlarız. Güvenlikteki eksiklikleri tespit eder, daimî olarak üst düzey güvenliği koruruz.',
	},
	{
		icon: 'fa-leaf',
		title: 'Bahçe & Peyzaj Hizmetleri',
		text: 'Yeşil alanlarınızın peyzaj planlaması, bakımı ve dönemsel düzenlemeleri uzman ekiplerimiz tarafından gerçekleştirilir; tesisinizin estetik değeri uzun vadeli korunur.',
	},
];

const ServicesPage = () => {
	return (
		<section className='services-page' id='hizmetlerimiz'>
			<SEO
				title="Hizmetlerimiz — 8 Alanda Uçtan Uca Yönetim · Proteam Yönetim"
				description="Genel bina yönetimi, bütçe, taşeron koordinasyonu, hukuk, teknik, temizlik, güvenlik ve peyzaj — site/apartmanınız için entegre yönetim hizmetleri."
				path="/hizmetlerimiz"
			/>
			<div className='services-page-inner'>
				<div className='services-header'>
					<span className='section-eyebrow'>Tüm Hizmetler</span>
					<h1 className='section-title'>Sekiz alanda uçtan uca yönetim</h1>
					<p className='section-lead'>
						Site ve apartman yönetiminde uçtan uca çözüm sunan dikey
						uzmanlık alanlarımız.
					</p>
				</div>
				<div className='card-cont'>
					{SERVICES.map((s) => (
						<article className='card' key={s.title}>
							<div className='card-icon'>
								<i className={`fa ${s.icon}`} aria-hidden='true'></i>
							</div>
							<h3 className='card-title'>{s.title}</h3>
							<p className='card-text'>{s.text}</p>
						</article>
					))}
				</div>
			</div>
		</section>
	);
};

export default ServicesPage;
